// src/admin/utils/dates.ts — CAT (UTC+2) display, relative time.
// Zambia does not observe DST, so a fixed +02:00 offset is fine.

const CAT_OFFSET_MIN = 120;
const CAT_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Africa/Lusaka',
  year: 'numeric', month: 'short', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hour12: false,
});
const CAT_DATE_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Africa/Lusaka',
  year: 'numeric', month: 'short', day: '2-digit',
});

export function formatCatDateTime(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return '—';
  return CAT_FORMATTER.format(d) + ' CAT';
}

export function formatCatDate(iso: string | Date | null | undefined): string {
  if (!iso) return '—';
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  if (isNaN(d.getTime())) return '—';
  return CAT_DATE_FORMATTER.format(d);
}

export function relativeTime(iso: string | Date, now: Date = new Date()): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso;
  const diffSec = (now.getTime() - d.getTime()) / 1000;
  const abs = Math.abs(diffSec);
  const past = diffSec >= 0;
  const suffix = (unit: string, qty: number) => {
    const plural = qty === 1 ? '' : 's';
    return past ? `${qty} ${unit}${plural} ago` : `in ${qty} ${unit}${plural}`;
  };
  if (abs < 60) return past ? 'just now' : 'in moments';
  if (abs < 3600) return suffix('minute', Math.round(abs / 60));
  if (abs < 86400) return suffix('hour', Math.round(abs / 3600));
  if (abs < 86400 * 7) return suffix('day', Math.round(abs / 86400));
  if (abs < 86400 * 30) return suffix('week', Math.round(abs / (86400 * 7)));
  return formatCatDate(d);
}

export function daysBetween(a: Date | string, b: Date | string = new Date()): number {
  const da = typeof a === 'string' ? new Date(a) : a;
  const db = typeof b === 'string' ? new Date(b) : b;
  return Math.floor((db.getTime() - da.getTime()) / 86_400_000);
}

void CAT_OFFSET_MIN; // kept for future use if we need manual arithmetic
